import { Typography } from '@material-ui/core';
import classNames from 'clsx';
import React from 'react';

import HTMLText from '@swf/components/HTMLText/HTMLText';

import { root } from './Info.scss';

interface Props {
  className?: string;
  message?: string;
  children?: React.ReactNode;
}

const Info: React.FC<Props> = ({ message, children, className }) => (
  <Typography className={classNames(root, className)} component="div">
    {message ? <HTMLText html={message} /> : children}
  </Typography>
);

export default Info;
